import { render, staticRenderFns } from "./UpdateLogo.vue?vue&type=template&id=614c31cc&scoped=true"
import script from "./UpdateLogo.vue?vue&type=script&lang=js"
export * from "./UpdateLogo.vue?vue&type=script&lang=js"
import style0 from "./UpdateLogo.vue?vue&type=style&index=0&id=614c31cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c31cc",
  null
  
)

export default component.exports